/** @file Step buttons of the Draw Order panel (forward, backward, front, back) and Clear key here. */
import type { Id } from '@pose2d/format/types';
import type { CatalogKey, Translate } from '@pose2d/i18n/types';
import { Button } from '../../ui-kit/Button';
import { orderMove, type OrderMove, type OrderStep } from './orderMove';

/** Props of DrawOrderSteps; `onClearKey` is set only when a draw-order key sits on the playhead frame. */
export interface DrawOrderStepsProps {
  t: Translate;
  order: readonly Id[];
  selected: Id | null;
  onMove: (move: OrderMove | null) => void;
  onClearKey?: (() => void) | undefined;
}

const STEPS: readonly [OrderStep, CatalogKey][] = [
  ['forward', 'panels.drawOrder.forward'], ['backward', 'panels.drawOrder.backward'], ['front', 'panels.drawOrder.front'], ['back', 'panels.drawOrder.back'],
];

/** The keyboard path to reordering (rows are buttons; no key handlers needed); a step that cannot move is disabled. */
export function DrawOrderSteps({ t, order, selected, onMove, onClearKey }: DrawOrderStepsProps) {
  const moveOf = (how: OrderStep): OrderMove | null => (selected === null ? null : orderMove.step(order, selected, how));
  return (
    <div className="rig-actions">
      {STEPS.map(([how, label]) => <Button key={how} label={t(label)} disabled={moveOf(how) === null} onClick={() => { onMove(moveOf(how)); }} />)}
      {onClearKey !== undefined && <Button label={t('panels.drawOrder.clearKey')} danger onClick={onClearKey} />}
    </div>
  );
}
